import { InfoboxesOptionsType } from "@/types/ModuleOptionsType";
import { customSanitize } from "../../../utils/customSanitize";
import { InfoBox } from "../InfoBoxes/InfoBox";
import { TextInfoBoxType } from "../InfoBoxesModule";
import { ContentTag } from "@/components/ContentTag/ContentTag";
import styles from "../InfoBoxesModule.module.scss";
import { ReactNode } from "react";

interface TextInfoBoxProps {
  text_infobox: TextInfoBoxType;
  columnsClass: string;
  fitHeight?: boolean;
  infoBoxOptions: InfoboxesOptionsType;
  extraClass?: string;
  headline: ReactNode;
  show_cardbox: boolean;
  show_divider: boolean;
  heading_level: number;
}

export const TextInfoBox = ({
  text_infobox,
  columnsClass,
  infoBoxOptions,
  extraClass,
  headline,
  show_cardbox,
  show_divider,
  heading_level,
}: TextInfoBoxProps) => {
  const { title, content } = text_infobox || {};

  return (
    <div
      className={`${styles["text-infobox-wrapper"]} columns ${columnsClass || ""}`}
    >
      <div className={`column is-12 is-6-desktop ${extraClass}`}>
        {headline}

        <span
          className="title"
          role="heading"
          aria-level={heading_level}
          dangerouslySetInnerHTML={{ __html: customSanitize(title) }}
        />

        <ContentTag extraClass="content" content={customSanitize(content)} />
      </div>

      <InfoBox
        extraClass={`${extraClass}`}
        type="textInfobox"
        textInfobox={text_infobox}
        infoBoxOptions={infoBoxOptions}
        show_cardbox={show_cardbox}
        show_divider={show_divider}
        heading_level={heading_level}
        layout="v2"
      />
    </div>
  );
};
